"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _VacatureItem = require("./VacatureItem");

var _VacatureItem2 = _interopRequireDefault(_VacatureItem);

require("../../Style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//renders the list of vacatures
var VacatureList = function VacatureList(props) {
  var AllVacatureName = [];

  //takes only the names of the vacatures so that it can be auto filled in the form
  var getAllVacatureName = function getAllVacatureName() {
    for (var i = 0; i < props.vacature.length; i++) {
      AllVacatureName.push(props.vacature[i].title);
    }
  };
  getAllVacatureName();
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "section",
      {
        id: "jobApplication",
        className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "light" : props.theme].join(" ")
      },
      _react2.default.createElement(
        "h2",
        null,
        props.title
      ),
      _react2.default.createElement(
        "div",
        { className: "card__list" },
        _react2.default.createElement(
          "div",
          { className: "card__container" },
          props.vacature.map(function (vacature) {
            return _react2.default.createElement(_VacatureItem2.default, {
              key: vacature.id,
              id: vacature.id,
              text: vacature.text,
              title: vacature.title,
              image: vacature.image,
              AllVacatures: AllVacatureName,
              mainColor: props.mainColor,
              pdf: vacature.pdf
            });
          })
        )
      )
    )
  );
};

exports.default = VacatureList;